<template>

</template>

<script>
export default {
    name: "Stepper",
    data() {
        return {
            intersectionObserver: null,
        }
    },
    methods: {
        observeVisibility() {

            const element = this.$refs.tabs.$el
            if (window.IntersectionObserver) {
                this.intersectionObserver = new IntersectionObserver((entries) => {
                    if (entries[0].intersectionRatio) {
                        this.$refs.tabs.onResize()
                    }
                }, {
                    root: document.body
                })
                this.intersectionObserver.observe(element)
            }
        },
        unObserveVisibility() {
            if (this.intersectionObserver) {
                this.intersectionObserver.disconnect()
            }
        },
    },
    mounted(){
        if(this.$refs.tabs) {
            this.observeVisibility();
        }
    },
    beforeDestroy() {
        this.unObserveVisibility();
    },
}
</script>

<style scoped>

</style>
